import { Button } from "@/components/ui/button";
import type { AutomationSummary } from "@/lib/data/schemas/automations";
export function AutomationCards({
  items,
  busy,
  onToggle,
  onEdit,
  onActivity,
  onRun,
  onDelete,
}: {
  items: AutomationSummary[];
  busy: boolean;
  onToggle: (item: AutomationSummary, enabled: boolean) => void;
  onEdit: (item: AutomationSummary) => void;
  onActivity: (item: AutomationSummary) => void;
  onRun: (item: AutomationSummary) => void;
  onDelete: (item: AutomationSummary) => void;
}) {
  return (
    <div className="space-y-3">
      {items.map((item) => (
        <article key={item.id} className="bg-card rounded-xl border p-5">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <h2 className="font-semibold">{item.name}</h2>
              <p className="text-muted-foreground mt-1 text-sm">
                {item.origin === "lawworks"
                  ? "Provided by LawWorks"
                  : item.scope === "user"
                    ? "Runs on your uploads"
                    : "Firm automation"}
              </p>
            </div>
            <label className="flex shrink-0 items-center gap-2 text-sm">
              <input
                type="checkbox"
                role="switch"
                aria-label={`Enable ${item.name}`}
                checked={item.enabled}
                disabled={busy}
                onChange={(event) => {
                  onToggle(item, event.target.checked);
                }}
              />
              {item.enabled ? "Enabled" : "Disabled"}
            </label>
          </div>
          <div className="mt-4 flex gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                onEdit(item);
              }}
            >
              Edit
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onActivity(item);
              }}
            >
              View activity
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onRun(item);
              }}
            >
              Run on a file
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onDelete(item);
              }}
            >
              Delete
            </Button>
          </div>
        </article>
      ))}
    </div>
  );
}
